import React, { SVGAttributes } from 'react';

// rationale: SVG paths are looooong

export function CircleWithCheckMark(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z'
        fill='#4CA667'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.9546 8.66602L11.3336 13.3441L9.24816 11.0688L6.93359 13.3949L11.2829 17.766L18.6336 10.3789L16.9546 8.66602Z'
        fill='white'
      />
    </svg>
  );
}
